import { Link } from 'react-router-dom';
import { tvShows } from '@/mocks/tvshows';

const featuredShows = tvShows.filter((s) => s.featured);

export default function HeroSection() {
  const mainShow = featuredShows[0];
  const subShows = featuredShows.slice(1, 4);

  if (!mainShow) return null;

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-end overflow-hidden" aria-label="精选推荐">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${mainShow.coverImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pb-10 md:pb-16 pt-32">
        <div className="max-w-screen-2xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 items-end">
            <div className="flex-1 max-w-2xl">
              <div className="flex items-center gap-3 mb-3 flex-wrap">
                <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                  今日推荐
                </span>
                <span className="text-sm text-background-50/80">|</span>
                <span className="text-sm text-background-50/80">{mainShow.year}</span>
                <span className="text-sm text-background-50/80">|</span>
                <span className="text-sm text-background-50/80">{mainShow.region}</span>
                <span className="text-sm text-background-50/80">|</span>
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-400 text-sm"></i>
                  <span className="text-sm text-accent-400 font-semibold">{mainShow.rating}</span>
                </div>
              </div>

              <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3">
                {mainShow.title}
              </h2>
              <p className="text-sm text-background-50/70 leading-relaxed mb-4 line-clamp-2 max-w-lg">
                {mainShow.description}
              </p>

              <div className="flex items-center gap-3 flex-wrap">
                {mainShow.genres.map((g) => (
                  <span
                    key={g}
                    className="px-3 py-1 text-xs border border-background-50/30 text-background-50/90 rounded-full whitespace-nowrap"
                  >
                    {g}
                  </span>
                ))}
              </div>

              <div className="flex items-center gap-3 mt-5">
                <Link
                  to={`/article/${mainShow.id}`}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-play-fill text-base"></i>
                  立即观看
                </Link>
                <Link
                  to={`/article/${mainShow.id}`}
                  className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-50/40 text-background-50 text-sm rounded-lg hover:bg-background-50/10 transition-colors whitespace-nowrap"
                >
                  <i className="ri-information-line text-base"></i>
                  详情介绍
                </Link>
              </div>
            </div>

            <div className="hidden lg:flex gap-4">
              {subShows.map((show) => (
                <Link
                  key={show.id}
                  to={`/article/${show.id}`}
                  className="group w-[140px] xl:w-[160px] flex-shrink-0"
                >
                  <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-2">
                    <img
                      src={show.posterImage}
                      alt={show.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                    <div className="absolute top-2 left-2">
                      <span className="px-2 py-0.5 text-[10px] bg-primary-500 text-background-50 rounded whitespace-nowrap">
                        {show.rating}
                      </span>
                    </div>
                  </div>
                  <p className="text-xs text-background-50/80 line-clamp-1 group-hover:text-background-50 transition-colors">
                    {show.title}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}